@if (isLoading()) {
  <div class="loading" [ngClass]="cssClass()" [style.width]="options()?.width" [style.height]="options()?.height"
    [style.margin-top]="options()?.marginTop" [style.margin-bottom]="options()?.marginBottom">
  </div>
}

@if (!isLoading()) {
  <ng-container *ngTemplateOutlet="templateRef() ?? null"></ng-container>
}
